import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import ImageGenPage from '../pages/imageGen';
import LibraryPage from '../pages/library';
import Seedance from '../pages/seedance';
import TasksPage from '../pages/tasks';
import WorkspacePage from '../pages/workspace';
import AgreementPage from '../pages/agreement';

const AppRouter = () => (
  <HashRouter>
    <Routes>
      <Route path="/" element={<Seedance />}>
        <Route index element={<Navigate to="/workspace" replace />} />
        <Route path="workspace" element={<WorkspacePage />} />
        <Route path="image-gen" element={<ImageGenPage />} />
        <Route path="library" element={<LibraryPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="agreement" element={<AgreementPage />} />
        <Route path="tasks/*" element={<TasksPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/workspace" replace />} />
    </Routes>
  </HashRouter>
);

export default AppRouter;
